import { render, staticRenderFns } from "./receiver.vue?vue&type=template&id=76b45af4&scoped=true&"
import script from "./receiver.vue?vue&type=script&lang=js&"
export * from "./receiver.vue?vue&type=script&lang=js&"
import style0 from "./receiver.vue?vue&type=style&index=0&id=76b45af4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b45af4",
  null
  
)

export default component.exports